import { render, staticRenderFns } from "./TextCommon.vue?vue&type=template&id=143859e4&scoped=true&"
import script from "./TextCommon.vue?vue&type=script&lang=ts&"
export * from "./TextCommon.vue?vue&type=script&lang=ts&"
import style0 from "./TextCommon.vue?vue&type=style&index=0&id=143859e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143859e4",
  null
  
)

export default component.exports